import { useRunWorkerDrawer } from "#src/contexts/RunWorkerDrawer";
import { Button, Icon, IconLoading } from "@validereinc/common-components";
import React from "react";

export const GlobalWorkerRunButton = () => {
  const { setIsOpen: setRunWorkerDrawerIsOpen, startedWorkerRunsCount } =
    useRunWorkerDrawer();

  return (
    <Button
      slotLeft={
        <Icon
          variant="cpu"
          size={18}
        />
      }
      size="xx-small"
      variant="outline"
      title="Worker Runs"
      onClick={() => {
        setRunWorkerDrawerIsOpen(true);
      }}
      slotRight={
        startedWorkerRunsCount > 0 ? (
          <>
            <IconLoading />
            {startedWorkerRunsCount}
          </>
        ) : null
      }
    />
  );
};
